import { Routes } from '@angular/router';
// Third party packages
// Custom packages - Misc
import { RoleGuard } from 'src/app/shared/guards/role.guard';
// Custom packages - Component
import { StatsListComponent } from 'src/app/modules/stats/pages/stats-list/stats-list.page';
var ɵ0 = {
    permissions: ['canReadStats']
};
var routes = [
    {
        path: 'list',
        component: StatsListComponent,
        canActivate: [RoleGuard],
        data: ɵ0,
    },
    {
        path: '**',
        redirectTo: 'it/errors/404'
    }
];
var StatsRoutingModule = /** @class */ (function () {
    function StatsRoutingModule() {
    }
    return StatsRoutingModule;
}());
export { StatsRoutingModule };
export { ɵ0 };
